import { useEffect, useRef, useState } from "react";
import { forgetExamImage, loadExamImage } from "../utils/examImages";

export default function ExamImage({ src, alt = "", onLoad, onError, ...props }) {
  const renderFailures = useRef(0);
  useEffect(() => { renderFailures.current = 0; }, [src]);
  const [round, setRound] = useState(0);
  const [state, setState] = useState(null);
  useEffect(() => {
    let active = true;
    setState(null);
    if (src) loadExamImage(src).then(
      url => { if (active) setState({ src, round, url }); },
      () => { if (active) setState({ src, round, failed: true }); }
    );
    return () => { active = false; };
  }, [src, round]);
  function retry() {
    renderFailures.current = 0;
    forgetExamImage(src);
    setRound(value => value + 1);
  }
  if (!src) return null;
  const current = state?.src === src && state?.round === round;
  if (current && state.failed) return (
    <span role="alert" style={{ display: "inline-block", padding: 12, border: "2px solid #b71c1c", color: "#b71c1c", background: "#fff" }}>
      Image could not load. Ask your teacher for help if retrying fails.{" "}
      <button type="button" onClick={retry}>Retry image</button>
    </span>
  );
  if (!current) return <span role="status">Loading image…</span>;
  return <img {...props} src={state.url} alt={alt} onLoad={onLoad} onError={event => {
    onError?.(event);
    // Even a previously preloaded image can fail after browser cache eviction.
    forgetExamImage(src);
    setState({ src, round, failed: true });
    if (++renderFailures.current < 3) setRound(value => value + 1);
  }} />;
}
